const sanitizeRedirectUrl = (url: string): string => {
  if (!url) {
    return url
  }

  // remove domain from the url, because we can redirect only to our domain
  return url.replace(/^([a-z]*?):?\/\/([^\/?]*)([\/?]?)/gi, '$3')
}

export default sanitizeRedirectUrl
